export const RDF_TYPE = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type';

export const SD = 'http://www.w3.org/ns/sparql-service-description#';
export const SD_DEFAULT_DATASET = `${SD}defaultDataset`;
export const SD_DEFAULT_GRAPH = `${SD}defaultGraph`;
export const SD_UNION_DEFAULT_GRAPH = `${SD}UnionDefaultGraph`;
export const SD_FEATURE = `${SD}feature`;
export const SD_GRAPH = `${SD}Graph`;

export const VOID = 'http://rdfs.org/ns/void#';
export const VOID_DATASET = `${VOID}Dataset`;
export const VOID_CLASSES = `${VOID}classes`;
export const VOID_TRIPLES = `${VOID}triples`;
export const VOID_ENTITIES = `${VOID}entities`;
export const VOID_CLASS = `${VOID}class`;
export const VOID_PROPERTY = `${VOID}property`;
export const VOID_VOCABULARY = `${VOID}vocabulary`;
export const VOID_URI_SPACE = `${VOID}uriSpace`;
export const VOID_URI_REGEX_PATTERN = `${VOID}uriRegexPattern`;
export const VOID_DISTINCT_OBJECTS = `${VOID}distinctSubjects`;
export const VOID_DISTINCT_SUBJECTS = `${VOID}distinctObjects`;
export const VOID_PROPERTY_PARTITION = `${VOID}propertyPartition`;
export const VOID_CLASS_PARTITION = `${VOID}classPartition`;
